import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'datetimeLocale'
})
export class DatetimeLocalePipe implements PipeTransform {
  static readonly DATE_FMT: string = 'dd/MM/yyyy HH:mm';
  static regexYear = /\d{4}/m;

  constructor(private datePipe: DatePipe) {}

  transform(isoDate: string, lang: string): string {
    if (!isoDate) {
      return '';
    }
    const dateEn: string = this.datePipe.transform(isoDate, DatetimeLocalePipe.DATE_FMT);
    if (lang === 'th') {
      return this.getDateTH(dateEn);
    }
    return dateEn;
  }

  private getDateTH(dateEn: string): string {
    const yearEn: RegExpExecArray = DatetimeLocalePipe.regexYear.exec(dateEn);
    return dateEn.replace(DatetimeLocalePipe.regexYear, this.getBuddhaYear(yearEn[0]));
  }

  private getBuddhaYear(year: string): string {
    const yearTh: number = parseInt(year, 10) + 543;
    return yearTh.toString();
  }
}
